import { useNavigate } from "react-router-dom";

import { Info4 } from "@assets";
import { BodySmall } from "@components/Typography";
import { BeneficiaryType, Routes } from "@ctypes";
import { useUser } from "@hooks";
import { i18n, Translations } from "@i18n";
import { BeneficiarySsnRouteFlow } from "@routes/BeneficiarySsnRoute/types";
import { isFiveTwoNineAccountType } from "@utils";
import { useStyles } from "./styles";

export const BeneficiarySsnBanner = () => {
  const { styles, iconFill } = useStyles();
  const navigate = useNavigate();
  const { beneficiaries } = useUser();

  const beneficiary = beneficiaries?.find((b) => {
    if (b?.type !== BeneficiaryType.Child) return false;
    if (b?.taxIdProvided) return false;

    return b?.goals?.some((goal) =>
      goal?.accounts?.some((account) => account?.type && isFiveTwoNineAccountType(account.type)),
    );
  });

  const beneficiaryId = beneficiary?.id;

  if (!beneficiaryId) return null;

  const handlePress = () => {
    navigate(Routes.Onboarding, {
      state: {
        initialStep: Routes.BeneficiarySsn,
        beneficiaryId,
        flow: BeneficiarySsnRouteFlow.HomeBeneficiarySsnCollection,
      },
    });
  };

  return (
    <div style={styles.container}>
      <button type="button" onClick={handlePress} style={styles.button}>
        <Info4 size={24} fill={iconFill} style={styles.icon} />
        <BodySmall style={styles.body}>
          {i18n.t(Translations.BeneficiarySsnBannerTitle, {
            name: beneficiary.firstName || i18n.t(Translations.BeneficiarySsnBannerDefaultName),
          })}
        </BodySmall>
      </button>
    </div>
  );
};
